import { UseGetAudienceSegmentsReturns } from '@occc/feat-segments';

import { GroupAudienceTargetingAttributesByType } from './utils';

export const prepareAudienceSegmentAttributes = (
  attributes: GroupAudienceTargetingAttributesByType,
  segments: UseGetAudienceSegmentsReturns['segments'],
) => {
  if (!segments?.length) {
    return [];
  }
  return attributes.segments.map((segment) => {
    const newSegments = segment.segmentIds
      .map((segmentId) => segments.find((item) => item.uuid === segmentId))
      .filter((segment): segment is UseGetAudienceSegmentsReturns['segments'][0] => !!segment);
    return {
      ...segment,
      segments: newSegments,
    };
  });
};
